import clsx from 'clsx'
import React, { FC } from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'
import styled from 'styled-components'

const BackdropWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zIndexes.backdrop};
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.55);
  transition: opacity 125ms ease-in-out;

  &.behindHeader {
    z-index: ${({ theme }) => theme.zIndexes.headerBackdrop};
  }

  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-active {
    opacity: 1;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
  }
`

interface BackdropProps {
  isShowing: boolean
  onBackdropClick?: () => void
  type?: string
}

export const Backdrop: FC<BackdropProps> = (
  {
    isShowing,
    onBackdropClick,
    type,
  }: BackdropProps,
) => (
  <CSSTransition
    classNames="fade"
    in={isShowing}
    mountOnEnter
    timeout={125}
    unmountOnExit
  >
    <BackdropWrapper
      aria-hidden
      className={clsx({
        behindHeader: type === 'behind-header',
      })}
      onClick={onBackdropClick}
    />
  </CSSTransition>
)
